import React from 'react';
import { OverflowMenu as Component } from '@vfuk/core-overflow-menu';
const OverflowMenu = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default OverflowMenu;
